module.exports = __webpack_public_path__ + "img/5-营销互动-01.0e1e11db.png";